import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { IntlShell } from '@/components/IntlShell';
import { UpdatePrompt } from '@/components/UpdatePrompt';

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <IntlShell>
      <Outlet />
      <UpdatePrompt />
    </IntlShell>
  );
}
